<script setup lang="ts">
import type { LinkEditModel } from "../../links/types";
import LinkForm from "../../links/LinkForm.vue";
import { useCurrentFileContext } from "../../useCurrentFileContext";

const emit = defineEmits<{
  submit: [LinkEditModel];
  cancel: [];
}>();

const url = defineModel<string>("url", { required: true });
const text = defineModel<string>("text");

const { shortcut } = useCurrentFileContext();

function submit(model: LinkEditModel) {
  emit("submit", model);
}

function handleKeyDownEscape() {
  emit("cancel");
}
</script>

<template>
  <div
    class="flex h-72 min-h-0 w-96 flex-col"
  >
    <LinkForm
      v-model:url="url"
      v-model:text="text"
      :shortcut="shortcut"
      @submit="submit"
      @cancel="handleKeyDownEscape"
    />
  </div>
</template>
